import { render, staticRenderFns } from "./CodeEmbedMod.vue?vue&type=template&id=f089446a"
import script from "./CodeEmbedMod.vue?vue&type=script&lang=js"
export * from "./CodeEmbedMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports